import { useLocalSearchParams } from 'expo-router'
import { useJob } from '@/hooks/jobs'
import { useJobLocations } from '@/hooks/locations'
import { useHeaderOptions } from '@/hooks/useHeaderOptions'
import { LoadingIndicator } from '@/ui/LoadingIndicator'
import { LocationsList } from '@/ui/locations/LocationsList'
import { NotFound } from '@/ui/NotFound'
import { Page } from '@/ui/Page'

export default function LocationsPage() {
    const params = useLocalSearchParams<{ orgSlug: string; jobSlug: string }>()
    const { job, isPending: isLoadingJob } = useJob(params.jobSlug)

    const { locations, isPending: isLoadingLocations } = useJobLocations(job?.id ?? '', {
        includeInactive: true,
    })

    useHeaderOptions({
        buttons: {
            type: 'create',
            title: 'Add',
            href: `/${params.orgSlug}/settings/jobs/${params.jobSlug}/locations/new`,
        },
        title: job ? `${job.name || job.identifier} Locations` : undefined,
        enabled: !!job,
    })

    if (isLoadingJob) {
        return <LoadingIndicator message="Loading job..." />
    }

    if (!job) {
        return (
            <NotFound message="Job not found. It may have been deleted or you don't have permission to view it." />
        )
    }

    return (
        <Page>
            <LocationsList
                locations={Array.isArray(locations) ? locations : []}
                isLoading={isLoadingLocations}
            />
        </Page>
    )
}
